import React from 'react';
import { Link } from "react-router-dom";

function FirstPage() {
    return (
        <>
            <div className="login-page" style={{ backgroundColor: '#337ab7', textAlign: 'center', padding: '10px' }}>

                {/* Header Row */}
                <div className="row align-items-center" style={{ backgroundColor: '#337ab7' }}>
                    <div className="col-12 col-md-9">
                        <h2 style={{ color: '#fff', fontWeight: 'bold', marginTop: '10px', fontSize: '1.5rem' }}>
                            GSTAT Deputation Application Portal
                        </h2>
                    </div>
                    <div className="col-12 col-md-3 text-center text-md-end mt-2 mt-md-0">
                        <img
                            style={{ maxHeight: '70px', width: 'auto', height: 'auto' }}
                            src="https://gstn.org.in/gstat-online-application/assets/img/logo.jfif"
                            alt="GSTAT Logo"
                        />
                    </div>
                </div>

                {/* Main Content */}
                <div className="login-page9-wrapper" style={{ width: '100%', marginTop: '20px' }}>
                    <div className="col-12 grid-margin stretch-card">
                        <div className="card" style={{ padding: '15px', textAlign: 'left' }}>
                            <p>
                                The Goods and Services Tax Appellate Tribunal (GSTAT) has been constituted by the Central Government under section 109 of the Central Goods and Services Tax Act, 2017 for hearing appeals against orders passed by the Appellate Authorities or the Revisional Authorities under the Act. The Principal Bench of the GSTAT is located at New Delhi and there shall be State Benches located in different States.
                            </p>
                            <p>
                                It has been decided to fill the posts of the subordinate staff for the GSTAT Tribunals on deputation basis. Accordingly, one time exemption from UPSC has been sought for filling up the said posts on deputation or consulting basis. You may click one of the links below to apply.
                            </p>
                            <p>
                                Follow-up Vacancy Circular for various posts in Principal and State Benches of GSTAT on deputation basis issued w.e.f. 14.08.2025. For the benefit of the applicants, posts have been specified location wise. Applicants are requested to read the Circular carefully before applying.
                            </p>

                            <p>
                                <b><Link to="/login">Click Here to Apply for Deputionist's / Login</Link></b>. The detailed vacancy circular with the detailed terms and conditions can be accessed <a href="./Vacancy_Circular.pdf" target="_blank" rel="noopener noreferrer">here</a>. Update open vacancy position PDF can be accessed <a href="./Vacancy Position.pdf" target="_blank" rel="noopener noreferrer">here</a>.
                            </p>

                            <p>
                                <b><a href="https://gstn.org.in/gstat-retiree-portal/">Click Here to Apply for Retired Central Govt. Servants as Consultants / Login</a></b>. The detailed vacancy circular, containing the vacancy position and the detailed terms and conditions can be accessed <a href="./vacancy circular for retired govt servants.pdf" target="_blank" rel="noopener noreferrer">here</a>
                            </p>
                            <p>
                                <b>In case of any difficulty kindly mail to: <Link to="mailto:support.gstat@gstn.org.in">support.gstat@gstn.org.in</Link></b>
                            </p>
                            <br />
                            <div className="ticker-container">
                                <div className="ticker-content">
                                    <span style={{fontWeight:'bold', color:'red'}}><marquee>1) The portal for application by Retiree is available wef 15-Jan-2026.  2) Please refer to the updated PDF for the current open positions count for Deputationist</marquee></span>
                                  
                                </div>
                            </div>
                            {/* <p>
                                <b>Important Notice for Applicants</b>: Submission of applications for the posts of staff and Officers of GSTAT has temporarily been kept on hold. The facility may be re-opened based on processing of the applications received and ascertainment of posts remaining vacant, if any.
                            </p> */}
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div className="row text-center text-md-start mt-4">
                    <div className="col-12 col-md-3 mb-2 mb-md-0">
                        <p style={{ color: '#fff', margin: 0 }}>© 2023-24 Goods and Services Tax Network</p>
                    </div>
                    <div className="col-12 col-md-6 mb-2 mb-md-0 text-center">
                        <p style={{ color: '#fff', margin: 0 }}>Version 1.0</p>
                    </div>
                    <div className="col-12 col-md-3 text-center text-md-end">
                        <p style={{ color: '#fff', margin: 0 }}>Designed & Developed by GSTN</p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default FirstPage;
